import { type ReactNode } from 'react';
import { usePersona } from '@/auth/usePersona';
import type { PersonaGuardProps } from '@/types/auth.types';

export function PersonaGuard({
  allowedPersonas,
  children,
  fallback,
}: PersonaGuardProps): ReactNode {
  const { hasPersona } = usePersona();

  if (hasPersona([...allowedPersonas])) {
    return <>{children}</>;
  }

  return fallback ?? null;
}
